import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import MathComponent from '../../MathComponent';
import { Popover } from '@ets/design-system';

import { Structure, Symbol } from 'Editor/modals/EquationsModal/ToolbarElements';
import CharGridItem from './CharGridItem';
import GridItem from './GridItem';

import { getModalContainer } from 'utils';
import styles from './ToolbarSection.module.scss';

type ToolbarSectionProps =
  | {
      type: 'structures';
      element: Structure;
    }
  | {
      type: 'symbols';
      element: Symbol;
    };

const ToolbarSection = ({ type, element }: ToolbarSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover.Root placement="bottom-start" open={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
      <div className={styles.section}>
        <Popover.Trigger asChild>
          <div
            className={styles.section}
            onClick={() => setIsOpen(!isOpen)}
            style={{ fontSize: element.sectionName === 'matrix' ? '1rem' : '2rem' }}
            data-testid={`toolbar-section-${element.sectionName}-trigger`}
          >
            <MathComponent mml={element.sectionElement} />
          </div>
        </Popover.Trigger>
        <Popover.Content testId="toolbar-section" container={getModalContainer()}>
          {!type || !element.elements ? null : (
            <div className={styles.popover}>
              <div className={styles.label}>
                <FormattedMessage id={element.label} />
              </div>
              <div className={type === 'structures' ? styles.grid : styles.char_grid}>
                {type === 'structures'
                  ? element.elements.map((element, i) => (
                      <GridItem key={element.label} element={element} testId={`structure-${i}`} />
                    ))
                  : element.elements.map((element, i) => (
                      <CharGridItem key={element.code} element={element} testId={`symbol-${i}`} />
                    ))}
              </div>
            </div>
          )}
        </Popover.Content>
      </div>
    </Popover.Root>
  );
};

export default ToolbarSection;
